import * as Constants from '../Constants';
import { DateTime } from 'luxon';

export const isValidDateTime = (date) => DateTime.isDateTime(date) && date.isValid;

/**
 * Returns a Luxon DateTime object set to the specific site timezone.
 * Luxon handles strings (ISO) or JS Date objects automatically.
 */
export const getTZDate = (date, sitetz) => {
  if (!date) return null;
  
  // If date is already a Luxon object, just set the zone
  if (DateTime.isDateTime(date)) {
    const dt = date.setZone(sitetz);
    return dt.isValid ? dt : null;
  }

  // If date is a JS Date object
  if (date instanceof Date) {
    const dt = DateTime.fromJSDate(date).setZone(sitetz);
    return dt.isValid ? dt : null;
  }

  // Otherwise assume ISO string
  const dt = DateTime.fromISO(date, { zone: sitetz });
  return dt.isValid ? dt : null;
};

export const getTZDateAsString = (date, sitetz) => {
  const dt = getTZDate(date, sitetz);
  return dt ? dt.toFormat(Constants.DATE_FORMAT_LUXON) : '';
};

export const getTZDateTimeAsString = (date, sitetz) => {
  const dt = getTZDate(date, sitetz);
  return dt ? dt.toFormat(Constants.DATE_TIME_FORMAT_LUXON) : '';
};
